const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

export const formatDate = (date) => {
    if (date === null)
        return;

    try {
        const datePart = date.split("-");

        const day = datePart[2]
        const month = monthNames[datePart[1] - 1];
        const year = datePart[0];

        const formattedDate = `${month} ${day}, ${year}`;

        return formattedDate;
    } catch (error) {
        console.log(error);
    }
    return;
}

export const formatDate2 = (date) => {
    var options = { month: 'short', day: 'numeric', year: 'numeric' };
    return date.toLocaleString('en-US', options);
}

/**
 * Locale-aware equivalent of formatDate, for an ISO yyyy-MM-dd string.
 *
 * formatDate above uses the English-only monthNames table, so a French or Dutch customer sees
 * English month abbreviations. Intl.DateTimeFormat handles that from the active checkout locale
 * ('en' | 'nl' | 'fr', per getSupportedLocale).
 *
 * Formatted in UTC deliberately: the API sends a UTC calendar date, and letting the browser
 * reinterpret it in local time shifts it a day for anyone behind UTC — the same off-by-one this
 * value is already guarded against server-side.
 *
 * Returns null rather than a partial or malformed string so callers can fall back cleanly.
 */
export const formatDateLocalized = (date, locale) => {
    if (!date)
        return null;

    try {
        // Strict ISO shape: exactly three components, four-digit year, zero-padded month and day.
        // The value always originates from Utils.FormatUnixDateUtc server-side, which emits
        // yyyy-MM-dd under InvariantCulture — so anything else means something upstream changed and
        // guessing would be worse than falling back. A bare split would have accepted "2026-7-30"
        // and silently ignored trailing junk in "2026-07-30-extra".
        const parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(date));
        if (!parts)
            return null;

        const year = Number(parts[1]);
        const month = Number(parts[2]);
        const day = Number(parts[3]);
        if (!year || !month || !day)
            return null;

        const value = new Date(Date.UTC(year, month - 1, day));
        if (isNaN(value.getTime()))
            return null;

        // Date.UTC rolls calendar overflow rather than rejecting it, so 2026-13-99 would silently
        // become Apr 9 2027 and 2026-02-29 would become Mar 1. Round-trip the components to confirm
        // the date we built is the date we were given.
        if (value.getUTCFullYear() !== year || value.getUTCMonth() + 1 !== month || value.getUTCDate() !== day)
            return null;

        return new Intl.DateTimeFormat(locale || 'en', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            timeZone: 'UTC'
        }).format(value);
    } catch (error) {
        console.log(error);
        return null;
    }
}

export const addMonthToCurrent = (monthsToAdd) => {
    var date = new Date();
    date.setMonth(date.getMonth() + monthsToAdd);
    return date;
}